import {Injectable} from '@angular/core';

@Injectable()
export class ConstantsKeyProviders {
  public assignedMold: string;
  public cutOrder: string;
  public cutOrderPart: string;
  public cycle: string;
  public cyclePart: string;
  public cycleLocation: string;
  public department: string;
  public file: string;
  public getInventoryCut: string;
  public hpProgress: string;
  public hpReport: string;
  public inspectedParts: string;
  public logs: string;
  public machine: string;
  public metadata: string;
  public metadataFile: string;
  public mold: string;
  public moldCycle: string;
  public moldLocation: string;
  public moveMold: string;
  public pallet: string;
  public palletLimit: string;
  public palletDetails: string;
  public tankReport: string;
  public part: string;
  public partAttachment: string;
  public role: string;
  public scannerConfig: string;
  public scannerLog: string;
  public schedule: string;
  public scheduleDetails: string;
  public scrapReason: string;
  public setVirtualContainer: string;
  public suffix: string;
  public task: string;
  public taskAttachment: string;
  public scannerProgress: string;
  public user: string;
  public userSuffix: string;
  // public userParts: string;
  public workInProgress: string;
  public workOrder: string;
  public workOrderByUser: string;
  public workOrderDetail: string;
  public workOrderUser: string;
  public workOrderUserHp: string;
  public workshift: string;
  public workshiftUser: string;
  public userAttendance: string;

  // Compression
  public compressionFormMachine: string;
  public compressionFormUser: string;
  public compressionFormPart: string;
  public compressionFormShift: string;
  public compressionFormProgress: string;
  public compressionFormAttachFile: string;

  // compression admin
  public compressionReport: string;
  public compressionProgress: string;
  public compressionPart: string;

  // HP
  public searchWorkOrder: string;
  public hpDetails: string;

  // CNC
  public cncCycle: string;
  public cncCycleDetails: string;
  public cncDevice: string;
  public cncPart: string;
  public cncDeviceConfig: string;
  public cncWorkOrder: string;
  public cncInventoryPart: string;
  public cncUpdateProgress: string;
  public cncTransaction: string;
  public cncOperation: string;

  // NETSUITE
  public getChildBOM: string;
  public getChildBOMLid: string;
  public getBOMParent: string;
  public getItem: string;

  // Lids
  public lidItem: string;
  public lidLocation: string;
  public lidStage: string;
  public lidTransaction: string;
  public lidProgress: string;
  public inventoryLid: string;

  constructor() {
    this.assignedMold =
      'TgeE3TUiTqDI/RurXfhQCpQ9p/vAW5BYVPvdMEabIwkwgfZXUaacpQ==';
    this.cutOrder = '8fvF6FA/FLBwTJhidX4NBlb5XPcSSzBwS2rznxHzCmPVSuICOiCpcA==';
    this.cutOrderPart =
      'kGS/vqCMV5q97EB0K1mlIW8NIDOWSfnia2wb2JLrgfaCe4RR6UZ1tQ==';
    this.cycle = 'pL14DgKTkAUEMGlYtRTE9yhmSHKW6RVeNdFikYUV8F1ByoGCf9INaQ==';
    this.cyclePart = 'YbcTPCB44KR4cRlioLQ0ZztXkEvkj1WyWLdvKdT6KkLJdUJNJ7k3xg==';
    this.cycleLocation =
      'mt3lQuv4ENLAsBqzy6DcAvKbE1zq3wq66/yinQedZHFgPboh7tyxMA==';
    this.department =
      'zfKntEoSMVaKdePATBc05cvuMu3GxI5kw7maQ4kmAZEZWZh6rYIVUA==';
    this.file = '/HmMy7GNqOkYOKy5Yg9SfaPltAfOI7R8rKBJBKPcJX6bsoaVAh8HMQ==';
    this.getInventoryCut =
      '/ng4UtOLSYU9k1xA9pNaETalLvasKHPGkDurGmENcsNf5K1kDjXkrQ==';
    this.hpProgress =
      'TBXmQC0QJAZ9BVzbp5sWKTPafqM3Gvph6KCAI1aVHoQtYCy3Ty5Svg==';
    this.hpReport = 'LhEEzH1crHf3Hfm13sfjJycW2UrgplNsC0rvKarmsiQHfzLCp4Qg0Q==';
    this.inspectedParts =
      'BDpzLy6Qms55ZFMPJ9ya91j/StFwmr6L7l1GVQxzSPxYXp65nbVY/w==';
    this.logs = '2FanjyJ97hzQb96PIa5A6qppILuQUG66F3/fkQARz7HdxFXnCAuXUQ==';
    this.machine = 'N68CdnVMa1JHNeB8bddCTUlGIft6B1SjZFfrwSwRu1gcS1bE6NHpPg==';
    this.metadata = 'GLBeCaZvGBm8B5DY09WogEmuFm7R1laLSpaXYvfVnRjJChXW797lug==';
    this.metadataFile =
      '7Yk5uU7k3jkQ3Esc7LXzalukTxXAvacnTVNX8sy9tO38ohrqUL1KlQ==';
    this.mold = 'VXz5Aj5qrXSMLLybFZ9pUV/6NcBoDOfTboysQhoa2TA1ZAlMVVEveg==';
    this.moldCycle = 'LFckbD/jhxOfBxgX1gZaS82yj5xxN67EsJQavttDCfcOWm9cMZaz9Q==';
    this.moldLocation =
      'eMwg8FsvNgU3ui8ukDa2aISw8RFsognryDe1tZMJTJ4E8fXhidqhZQ==';
    this.moveMold = 'aMSNWcWDaCbZIcnIG99ksx26GCIPavbIny0PQDWzc/fNLJOdHaU1EA==';
    this.part = 'YjgRDbUxCXABmYLrCRyshwmIYzvz2PYguMOYYAPYsmjqddfJojDStA==';
    this.partAttachment =
      'FYO5wxxaPoqE1UL2fx5OsR5dFyL0OqzamlVVtRWGVXHakIWIkaKb5w==';
    this.role = 'c1UiGN2OismW8BAyWQWERU4wLhcqcLgzyxzEfdu6h8w0LenaddEQAQ==';
    this.scannerConfig =
      '5g5NJKg8L4V1SCtbtwBPSEbfaPihmLLSGn7uAoTsZftHC1tOpuLtiw==';
    this.scannerLog =
      'uzBUWB1IZpbV5n67qXtlhIaJXS9bJ982YenJPiHY3KmL5HwjKjnW8w==';
    this.schedule = 'jnqLkaHUBAxADNIytqzUjvU4ay0ndzxByJRwT4ev8sFW7eqUbumT1A==';
    this.scheduleDetails =
      'GvOpoqKKyGB7qp1yVCjlp4nHL7WafcQg0mcDNuuDi/o9RmZvnv2NVA==';
    this.scrapReason =
      'KhNnUaU656GiceYq0zkHHfEc7RYZ72ZVI49IWFU6skS6w961I3K7Iw==';
    this.setVirtualContainer =
      'exVexfMjFbv7ZxQoVOjx/5snyXxMbODF2ml04sAkO74AaKdvJSMtDA==';
    this.suffix = 'AEismcXwvhnlehYyx8qGCxGeOtKZueyLh9SPJDGN2evMJNcJikSNag==';
    this.task = 'ZsdAFAV9BvR0fRHNQJR0CxvqYxCNihFI4sy427/3JS9Dvq6g8BNoVg==';
    this.taskAttachment =
      'FeNpaeyhQoLFHxeuzFRQx3bsHftgjpDjgAVft62yBq5WvQvgbqi65w==';
    this.scannerProgress =
      'QtK8fekeTYEBLQ9vCYCFTMPKSO29TR0xsrrd3v3URJ2POYRxi8NIag==';
    this.user = 'AVGpZ9uSF53KBbtbHjxNXMqJnaXFRWJG57Iuyzuqg9WvS3fBkiee6A==';
    this.userSuffix =
      'ZbslsiYvZ8GuxE9kMt/k6ZCvXdLHhtH84VDdZNHrdT5FLLq7PJ2bGw==';
    // this.userParts = 'dElaUK/mwUNk5dyJqUa/uek4ifxwNV2fJ6XX3AiZiRxPqClQiGoJUA==';
    this.workInProgress =
      'nep3SWMaLwlhhza4hCW5fbGSAoUJrnmcaMaZOOOvdoXN92oXhuhBTg==';
    this.workOrder = '5Vym3kBwTusTBcz/QurLJywUiPxnITylJgabQsswsm5Y46BN4cymeg==';
    this.workOrderByUser =
      'WzGa8hRFjASqC3yWOVP769nr4cVP9ZQ6dKSyKZI4YjtLmliWUly0Lg==';
    this.workOrderDetail =
      '4UGVa1Rdao0FnaitEO7soSHBxPoPb8crNWilSQEVdjN1XfQOapX5cg==';
    this.workOrderUser =
      'CafBz1KC/d9GBI4F/q1cUkYdeDLWHvTZDG6fUWLUaFmkWoRsJpGGzA==';
    this.workOrderUserHp =
      'w6TlKSdfM3Rk2J6m//akdiOnGj135tphLNUqU9OX1laARxRB/hQywg==';
    this.workshift = 'ZZ1QKMC3OVGDLr9dXFecDNvtVMmMhS/ILfegq1BTZa5ThbDDujjjjQ==';
    this.workshiftUser =
      'cWeXPp2wbAiJz37z9pFuNb6lD2zq7Yi1mBL/pAUVVZLnZDVvI8bulA==';

    this.userAttendance =
      'MfyhKKT5PxQ14MwjFood6i970l6lFRZ/haEasa6XYOmEqqjXgyH/2A==';

    this.compressionFormMachine =
      'aOnQkAwyqvwGPCgwrkERatGlfKlJWJSjDXYrtIWi25r39C9lcZCH8g==';
    this.compressionFormUser =
      'lZgnJaFamHEw/tVRP0Ja3pACRmGUDeI7xWHalyqCEDik4dUdP8adYw==';
    this.compressionFormPart =
      'jAEWmbv0aXAK/OLDdAG4gC5loEmapQkCTzpKI/pJVs8ohYMAdUhs1Q==';
    this.compressionFormShift =
      'sX8kazisOzfXbCG9vYwwz6vsTs5oFkOhhs2gm0jtZlM8SmNjFTsCfQ==';
    this.compressionFormProgress =
      'O77pkJXPa5fDc37lyfVlDskytHzZzx39w9MoSwYx8HHA26FprEGRiA==';
    this.compressionFormAttachFile =
      'lv0kTtj1Lcv9OaL48NVbYxTtzLuBENeiuBIt17h5C37iy/xd5RBk0Q==';

    this.compressionReport =
      'A6/kzhvaaX0dItrIdCdk6XNcyaBXr90f7ujQpPgTeaLnVJd2L2mU0A==';
    this.compressionProgress =
      '7JGk6woDqV0fjrEt3Dyt12zvp0sJp3xx0TrNwCobtUb8HyAqXBPDTg==';
    this.compressionPart =
      'ics2FIheYoi2Vk3HCzmdxLFhUMrjh3881lsgwsixwX/YqETg5EmnDw==';

    this.searchWorkOrder =
      'XA95_yMp29c4jc8uGvAx_6AaZmPhP9HK92w3teW2UglzAzFu9U3dQQ==';
    this.hpDetails = '3SGyFIaJynkS7uoWWOBa_lZfRV97tfjD6YhY0EMpEdrrAzFuavvomg==';
    this.getChildBOM =
      'c2w5XXW8hC3BEChgfBlzhAILudJmlV-UJWv82lm-XK1SAzFuVwdNTg==';
    this.getChildBOMLid =
      '-a5irZpHiwdnBg71QpqxV9Q-sGiAYDeJVudyKOUc1qcvAzFu0LcOWA==';
    this.getBOMParent =
      'MtIlCG2fQ6LEJRcEEX4ZUJ7wEqeYsqrH_nM6hUtFVgtBAzFutnj-Xw==';
    this.getItem = 'pfPqANPzcGQ9fZafQIWA5XxK_9uEevNATmGzduaLFEtZAzFuzPXJMQ==';

    this.cncPart = 'fvNa4WNlop79LB6RkCcxHTmtaUzYT7V6kVIyeZeaDLpAzgUnBX65Lw==';
    this.cncCycle = 'ffgYQ7maSuKMynd34ut8y9HZ65pMMo7iWEZPavamNYUcX2JbT0IclQ==';
    this.cncDevice = '6VwaYBQDPG8NsMd8Zmg6iFsa4CQdqFxGU9e0wZ6EjmRMt/4DaZuoOw==';
    this.cncCycleDetails =
      'gIFYd50qcIN0iGrc6ojMrLXHigbGvfYoMnAD0MdWyxLYkLHZUsX10Q==';
    this.cncDeviceConfig =
      '3rgBa648RucmzLSlmuvoZDyaRjTQ6BPEhbAPz9QKjvlcaP4gArThYQ==';
    this.cncWorkOrder =
      'BNONmkJIzk6Z9FUHUy9tdFNrNJfSTUkcrQjJOauaKteyUCMA2PbZHA==';
    this.cncInventoryPart =
      'qVi1m0WgWaMac2hd/y62TqBXSwF9alx6d7z1cBTG5fgcF/IyIiWjKQ==';
    this.cncUpdateProgress =
      'daq7ZvcgOND69ddT6EjsoKRYM1e2CobvvPM/TG83nhxSsB/gh55ypQ==';
    this.cncTransaction =
      'bgswB6kaeGwTKCmRNeindqYesanmH7U5Kdl/lloJrD7C/kj33edlhw==';
    this.cncOperation = '';

    this.lidItem = 'n7haIGVV7hIpuOn5Lq3VcRkozDY5FgyF4cM1TqqWrZfOEB8VjHmlCg==';
    this.lidLocation =
      'kzypzoL8wJwNRdcMAgAr9DyHCHE5FIQdFTqGUgOx5BqvSQfwsoneDQ==';
    this.lidStage = 'PHckJu4L74Ms1xxQ77aStFcXswzrOZWOR1N5n3pHeiuM4KKaspCU/w==';
    this.lidTransaction =
      '/GPEQfpwykHhS3vfvCugj6IdvmRoWjGzC2GqN2Ltwcx207jdsAkDjQ==';
    this.lidProgress =
      '27pu0vEEnCXHCns4Vt3FV3eVIlHW15iWpP5xjEN7PaWgQIVy2srmFA==';
    this.inventoryLid =
      'xwFvJdCE2Lpa8L6pLgn6VEnisafVbySo54p3vlXF5DqK5hheI/rXFA==';

    this.pallet = 'wtJkFAs6xqT0HawlVjEbfZU2gZwIinZr0UC8a1dRdizsAlj4gPsn7w==';
    this.palletLimit = '';
    this.palletDetails =
      'momzPxSwmytWaY9Uhg6jzdPA5LWWUe981kZNiNo0LN61hcTMXNJ3UQ==';
    this.tankReport =
      'RxY4tZsbMIZhgrmb1pXuNsT7ux0hh2sToankFaMuPbP7afUB/HwmSg==';
  }
}
